import { push } from "connected-react-router";
import {
  ADD_USER,
  ASYNC_END,
  ASYNC_START,
  FETCH_FAILED,
  FETCH_START,
  FETCH_SUCCESS,
  DELETE_USER,
  UPDATE_USER
} from "./types";
import NotificationService from "../services/notification.service";
import UserService from "../services/user.service";
import { get, isEmpty, omit } from "lodash";
import normalize from "json-api-normalizer";
import { setResouceType } from "../reducers/resources.reducer";
const RESOURCE_TYPE = "users";

export const addUser = attrs => async dispatch => {
  dispatch(setResouceType(RESOURCE_TYPE));
  dispatch({ type: ASYNC_START, subtype: ADD_USER });

  try {
    await UserService.addUser(attrs);
    NotificationService.addSuccess(`User added successfully!`);
    dispatch({ type: ASYNC_END });
    dispatch(push("/users"));
  } catch (error) {
    dispatch({ type: ASYNC_END });
    NotificationService.addError(`Could not add user! ${NotificationService.handleMessage(error)}`);
    dispatch({ type: ADD_USER, payload: error.response, error: true });
  }
};

export const updateUser = (id, attrs) => async dispatch => {
  dispatch(setResouceType(RESOURCE_TYPE));
  dispatch({ type: ASYNC_START, subtype: ADD_USER });

  try {
    const newAttrs = isEmpty(attrs.password) ? omit(attrs, ["password", "passwordConfirmation"]) : attrs;
    await UserService.updateUser(id, newAttrs);
    NotificationService.addSuccess(`User updated successfully!`);
    dispatch({ type: ASYNC_END });
    dispatch(push("/users"));
  } catch (error) {
    dispatch({ type: ASYNC_END });
    NotificationService.addError(`Could not update user! ${NotificationService.handleMessage(error)}`);
    dispatch({ type: ADD_USER, payload: error.response, error: true });
  }
};

export const changePassword = (id, password) => async dispatch => {
  dispatch(setResouceType(RESOURCE_TYPE));
  dispatch({ type: ASYNC_START, subtype: UPDATE_USER });

  try {
    await UserService.updateUser(id, password);
    NotificationService.addSuccess(`Password changed successfully!`);
    dispatch({ type: ASYNC_END });
    dispatch(push("/"));
  } catch (error) {
    dispatch({ type: ASYNC_END });
    NotificationService.addError(`Could not update user! ${NotificationService.handleMessage(error)}`);
    dispatch({ type: ADD_USER, payload: error.response, error: true });
  }
};

export const deleteUser = id => async dispatch => {
  dispatch({ type: ASYNC_START, subtype: DELETE_USER });
  dispatch(setResouceType(RESOURCE_TYPE));

  try {
    await UserService.delete(id);
    dispatch({ type: DELETE_USER });
    dispatch({ type: ASYNC_END });

    NotificationService.addSuccess("User successfully deleted!");
    dispatch(fetchUsers());
  } catch (e) {
    dispatch({ type: DELETE_USER });
    NotificationService.addError(`Failed deleting the user! ${NotificationService.handleMessage(e)}`);
    dispatch({ type: ADD_USER, payload: e.response, error: true });
  }
};

export const fetchUsers = () => async dispatch => {
  dispatch({ type: FETCH_START, payload: { page: 1 } });
  dispatch(setResouceType(RESOURCE_TYPE));

  try {
    const result = await UserService.getAll();
    const data = normalize(result.data);

    dispatch({
      type: FETCH_SUCCESS,
      payload: data
    });
  } catch (e) {
    dispatch({ type: FETCH_FAILED, payload: get(e, "response.data", {}) });

    NotificationService.addError(`Could not fetch users. ${NotificationService.handleMessage(e)}`);
  }
};

export const fetchUser = id => async dispatch => {
  dispatch({ type: FETCH_START, payload: { page: 1 } });
  dispatch(setResouceType(RESOURCE_TYPE));

  try {
    const result = await UserService.get(id);
    const data = normalize(result.data);

    dispatch({
      type: FETCH_SUCCESS,
      payload: data
    });
  } catch (e) {
    dispatch({ type: FETCH_FAILED, payload: get(e, "response.data", {}) });

    NotificationService.addError(`Could not fetch user. ${NotificationService.handleMessage(e)}`);
  }
};
